import * as React from 'react';
import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';
import { IGIInputProps } from './GIInput';

type GIFormLabelPropsPicked = 'className' | 'children' | 'aria-label' | 'onChange';

interface IGIFormLabelProps extends Pick<ComponentPropsWithoutRef<'label'>, GIFormLabelPropsPicked>, Pick<IGIInputProps, 'name' | 'required' | 'type'> {
  id: string;
  hideLabel?: boolean;
}

export const GIFormLabel = ({
    id,
    className,
    children,
    name,
    required,
    type = 'text',
    'aria-label': ariaLabel,
    onChange,
    hideLabel = false,
}: IGIFormLabelProps) => {
    const computedClassNames = {
        checkbox: 'usa-checkbox__label gi-checkbox__label',
        text: 'gi-input__label'
    };
    const labelClassName = computedClassNames[type] || 'gi-input__label';

    return (
        <label
            id={id}
            data-automation-id={id}
            data-testid={id}
            htmlFor={name}
            aria-label={ariaLabel}
            className={clsx(labelClassName, className, `required-${required}`)}
            onClick={onChange}
        >
            {hideLabel ? <span className="sr-only">{children}</span> : children}
        </label>
    );
};